import { Box, Stack, Typography } from '@mui/material';
import { useGlobalStore } from '@old/global-store/use-store';
import { useNavigate } from 'react-router';
import '../../index.css';
import i18n from '../../libs/language';
import { useEffectOnMount } from '@old/hooks/core';
import { useConnection } from '@old/hooks/use-connection';
import { useEffect } from 'react';
import { PATH } from '@old/data/core/paths';

// Importar las imágenes como módulos estáticos
import fondoVerdeUrl from '@old/assets/screen/no-connection/fondo-verde.svg';
import trigoUrl from '@old/assets/screen/no-connection/trigo.svg';

export function NotConnectedPage() {
  const { email } = useGlobalStore();
  const navigate = useNavigate();

  const isOnline = useConnection();

  useEffect(() => {
    if (!isOnline) {
      navigate(PATH.NO_CONNECTION);
    } else if (isOnline && email) {
      navigate(PATH.DASHBOARD);
    } else if (isOnline && !email) {
      navigate(PATH.LOGIN);
    }
  }, [isOnline]);

  // Las imágenes ya están disponibles como imports estáticos

  const { setLanguage } = useGlobalStore();

  useEffectOnMount(() => {
    const browserLanguage = navigator.language;
    switch (browserLanguage) {
      case 'pt':
      case 'pt-BR':
        i18n.locale = 'pt';
        setLanguage(i18n.locale);
        localStorage.setItem('LANGUAGE_PREFERENCE', 'pt');
        break;
      case 'es':
      case 'es-ES':
        i18n.locale = 'es';
        setLanguage(i18n.locale);
        localStorage.setItem('LANGUAGE_PREFERENCE', 'es');
        break;
    }
  });

  return (
    <Stack direction={'row'} style={{ overflow: 'hidden' }} className="keep-scrolling-without-scroll">
      <Box width={'50vw'} height={'100vh'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <Stack
          style={{ zIndex: 5, position: 'relative' }}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'start'}
          width={{ xs: '100%', md: '60%' }}
          marginLeft={'30%'}
        >
          <Typography
            width={'100%'}
            sx={{ color: { xs: '#ffff', md: '#49454F' } }}
            fontSize={30}
            fontWeight={'bold'}
          >
            {i18n.t('app.no_connection')}
          </Typography>
        </Stack>
      </Box>
      <Box width={'50vw'} height={'100vh'} margin={0} display={'flex'} position="relative">
        <Box
          style={{ zIndex: 2, position: 'relative' }}
          height={'100vh'}
          display={'flex'}
          alignItems={'center'}
        >
          <img src={trigoUrl} style={{ zIndex: 2, position: 'relative', width: '100%' }} />
        </Box>
        <Box
          width={'50%'}
          height={'100vh'}
          display={'flex'}
          justifyContent={'end'}
          alignItems={'end'}
          style={{ zIndex: 1, position: 'relative' }}
        >
          <img
            src={fondoVerdeUrl}
            style={{
              width: '100vw',
              height: '100vh',
              backgroundColor: '#6BAA00',
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
}
